

import { NAVIGATION_ACTION } from './actionType';

export const admisionReducer = (state = { list:[] }, action = {payload:{}, type:''}) => {
   
   switch(action.type){

      case NAVIGATION_ACTION: {

         return { ...state, navigatioPage: action.payload }
      }

       case 'changeAdmissionId':{
           const { admissionId } =  action.payload
           return { ...state, admissionId }
        }

    case 'changeArray': {
       const { list } =  action.payload
       return { ...state, list }
    }
    case 'changeStateAdmisionId':{
  
       const { estadosAdmisionId } =  action.payload
       return { ...state, estadosAdmisionId: estadosAdmisionId }
    }

    case 'changeClasificationId':{
  
       const { clasificationId } =  action.payload
       return { ...state, clasificationId: clasificationId }
    }

    case 'changeProgramId':{
  
       const { programId } =  action.payload
       return { ...state, programId }
    }

    case 'changePeriodId':{
  
       const { periodId } =  action.payload
       return { ...state, periodId }
    }

    case 'changeCampusId':{
  
       const { campusId } =  action.payload
       return { ...state, campusId }
    }

    case 'changeAllSelect':{
        
       const { campusId, periodId, programId } =  action.payload
       return { ...state, campusId, periodId, programId }
    }

    case 'changePeriodAndCampus':{
       const { campusId, periodId } =  action.payload
       return { ...state, campusId, periodId }
    }

    case 'changeAllSelectAndAdmission':{
        
       const { campusId, periodId, programId, admissionId } =  action.payload
       return { ...state, campusId, periodId, programId, admissionId }
    }

    default: return state 
   }
}
